import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import MUIButton from '@material-ui/core/Button';
import Color from 'color';

const TEXT = 'text';

const StyledButton = styled(MUIButton)`
  padding: 4px ${props => (props.appearance === TEXT ? props.theme.spacing[1] : props.theme.spacing[2])};
  ${props => props.theme.typography.button};
  box-shadow: none;
  border-radius: 36px;
  white-space: nowrap;

  color: ${props => props.theme.colors.text.primary};
  border-style: solid;

  & .MuiButton-label {
    position: relative;
    top: 2px;
  }

  &.MuiButton-root {
    &:hover {
      background-color: ${props => Color(props.theme.colors.text.primary).fade(0.96).string()};
    }
  }

  &.MuiButton-containedPrimary {
    ${props => !props.disabled && css`
      background-color: ${props.theme.colors.brand.primary};
      color: ${props.theme.colors.text.primary};
    `}

    &:hover {
      background-color: ${props => Color(props.theme.colors.brand.primary).mix(Color(props.theme.colors.text.primary), 0.04).string()};
    }
  }

  & .MuiSvgIcon-root {
    position: relative;
    top: -3px;
    margin-right: ${props => props.theme.spacing[1]};
  }
`;

const Button = ({
  appearance,
  startIcon,
  children,
  ...rest
}) => {
  if (appearance === TEXT) {
    return (
      <StyledButton
        appearance={appearance}
        {...rest}
      >
        {startIcon}
        {children}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      appearance={appearance}
      variant="contained"
      color="primary"
      {...rest}
    >
      {startIcon}
      {children}
    </StyledButton>
  );
};

Button.TEXT = TEXT;

Button.propTypes = {
  appearance: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  startIcon: PropTypes.node,
};

Button.defaultProps = {
  appearance: '',
  startIcon: null,
};

export default Button;

